import { useCompanyCurrency } from 'src/core/modules/app/hooks/useCompanyCurrency';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';
import { useWalletTransactionForecastQuery } from 'src/core/modules/company/hooks';

import { walletAmountAllocationToCheckForMissingFunds } from '../models';
import { selectors, useSelectorWithContext } from '../redux';
import { useQuotes } from './api';

export const useWalletTransactionForecastOnSelectedTransfersQuery = () => {
  const companyId = useCompanyId();

  const companyCurrency = useCompanyCurrency();

  const selectedTransfers = useSelectorWithContext(
    selectors.selectTransfersSelected,
  );

  const { totalAmountWithQuotes } = useQuotes({
    companyId,
    companyCurrency,
    selectedTransfers,
  });

  const getWalletTransactionForecastQueryState =
    useWalletTransactionForecastQuery();

  return (): ReturnType<typeof getWalletTransactionForecastQueryState> =>
    getWalletTransactionForecastQueryState(
      totalAmountWithQuotes,
      walletAmountAllocationToCheckForMissingFunds,
    );
};
